import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export const API_URL = process.env.VUE_APP_API_URL || 'https://api.rmsfiliera.it/';
export const API_WS_URL = process.env.VUE_APP_API_WS_URL || 'wss://api.rmsfiliera.it/emma/admin/notifications';
const httpService = axios.create({
    baseURL: API_URL
});

export default httpService;

